__turbopack_context__.v({
  "dark": "lZsujq_dark",
  "widgetCloseBtn": "lZsujq_widgetCloseBtn",
  "widgetPane": "lZsujq_widgetPane",
  "widgetPaneContent": "lZsujq_widgetPaneContent",
  "widgetPaneHeader": "lZsujq_widgetPaneHeader",
  "widgetPaneOpen": "lZsujq_widgetPaneOpen",
});
